import { request } from './request.js'

export const getOrders = () => request.get('orders')
export const getOrdersSearch = params => request.get('orders/search', { params })
export const getOrdersById = id => request.get('orders/' + id)
export const createOrders = data => request.post('orders', data)
export const updateOrders = (id, data) => request.put('orders/' + id, data)
